import type { Trigger } from "@tiptap/suggestion";

export function findSuggestionMatch(config: Trigger) {
	const { $position } = config;

	const regexp = new RegExp(`([0-9A-Za-z_.]+)`, "g");

	const text = $position.nodeBefore?.isText && $position.nodeBefore.text;

	if (!text) {
		return null;
	}

	const textFrom = $position.pos - text.length;
	const match = Array.from(text.matchAll(regexp)).pop();

	if (!match) {
		return null;
	}

	// The absolute position of the match in the document
	const from = textFrom + match.index;
	const to = from + match[0].length;

	// If the $position is located within the matched substring, return that range
	if (from < $position.pos && to >= $position.pos) {
		return {
			range: {
				from,
				to,
			},
			query: match[0],
			text: match[0],
		};
	}

	return null;
}
